import React, {Component, useState} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert } from 'react-bootstrap';
import JobDataService from "./services/job.service";
import { Navigate } from 'react-router-dom';
import { IoIosArrowBack } from "react-icons/io";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import SearchClient from './SearchClient';
import TopAndSideBar from './TopAndSideBar';
import { NewHeader } from './AuxiliaryFunctions';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

const renderTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to see details of the item.
  </Tooltip>
);

class NewJob extends Component {  

  constructor(props) {
    super(props);
    this.onChangeJobTitle = this.onChangeJobTitle.bind(this);
    this.onChangeJobDescription = this.onChangeJobDescription.bind(this);
    this.onChangeJobStartDate = this.onChangeJobStartDate.bind(this);
    this.onChangeJobDueDate = this.onChangeJobDueDate.bind(this);
    this.onChangeJobClient = this.onChangeJobClient.bind(this);
    this.onSelected = this.onSelected.bind(this);
    this.saveJob = this.saveJob.bind(this);
    this.retrieveJobs = this.retrieveJobs.bind(this);
    this.refreshList = this.refreshList.bind(this);    
    this.handleValidations = this.handleValidations.bind(this);
    this.goToJobsList = this.goToJobsList.bind(this);

    this.state = {
      id: null,
      jobtitle: "",
      jobaddress: "",
      jobdescription: "",
      jobstartdate: "",
      jobduedate: "",
      jobclient: "",
      submitted: false,
      jobs: [],
      currentJob: null,
      currentIndex: -1,  
      showerror: false,
      errmessage:'',   
      showsuccess: false,
      succmessage: '',
      selectedclient: '',
      selectedclientname: ''
    };
  }

  onSelected(idSelVal, descSelVal) {    
    this.setState({selectedclient:idSelVal});
    this.setState({selectedclientname:descSelVal});    
  }  

  goToJobsList() {
    window.location.assign('/jobs');
  }

  handleValidations() {
    if (this.state.jobtitle.length==0 || this.state.selectedclient.length==0) {
      this.setState({errmessage:'Fields can not be empty.'})
      this.setState({showerror:true})
      return;
    }
    this.saveJob();
  } 


  retrieveJobs() {
    JobDataService.getAll()
      .then(response => {
        this.setState({
            jobs: response.data
        });
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  }

  refreshList() {
    this.retrieveJobs();
    this.setState({
        currentJob: null,
        currentIndex: -1
    });
  }

  onChangeJobTitle(e) {
    this.setState({
        jobtitle: e.target.value
    });
  }

  onChangeJobAddress(e) {
    this.setState({
        jobaddress: e.target.value
    });
  }  

  onChangeJobDescription(e) {
    this.setState({
        jobdescription: e.target.value
    });
  }

  onChangeJobStartDate(e) {
    this.setState({
        jobstartdate: e.target.value
    });
  }  

  onChangeJobDueDate(e) {
    this.setState({
        jobduedate: e.target.value
    });
  }   

  // I thnink this is not needed... 
  onChangeJobClient (e) {
    this.setState({
        jobclient: e.target.value
    });    
  }

  saveJob() {
    var data = {
        jobtitle: this.state.jobtitle,
        jobaddress: this.state.jobaddress,
        jobdescription: this.state.jobdescription,
        jobstartdate: this.state.jobstartdate,
        jobduedate: this.state.jobduedate,
        clientId: this.state.selectedclient
    };

    JobDataService.create(data)
      .then(response => {
        this.setState({
          // id: response.data.id,
          jobtitle: response.data.jobtitle,
          jobaddress: response.data.jobaddress,
          jobdescription: response.data.jobdescription,
          jobstartdate: response.data.jobstartdate,
          jobduedate: response.data.jobduedate,
          submitted: true          
        });
        this.setState({errmessage:''});
        this.setState({showerror:false});
        this.setState({succmessage:'Job has been created. Redirecting to job list...'});
        this.setState({showsuccess:true});           
        this.refreshList();
        console.log(response.data);
      })
      .catch(e => {
        this.setState({errmessage:e.response?e.response.data.message:e.message})       
        this.setState({showerror:true})
        this.setState({succmessage:''})
        this.setState({showsuccess:false}) 
      });
  }

  render() {
    return (
      <>
      <div style={{display:"flex", flexDirection:"column",width:"100%"}}>
        <TopAndSideBar />
        <NewHeader headerTitle={"New Job"}/>

        <div style={{padding:"0 8vw",}}>
          
          <Row className='md-3' lg={8}>
            <FormLabel className='mb-2'>Client:</FormLabel>       
          </Row>
          <Row className='md-3'>
            <FormControl style={{maxWidth:"300px"}} className='ms-2' type="text" name="client" id="client" onChange={this.onChangeJobClient} disabled defaultValue={this.state.selectedclientname}></FormControl>
            <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip}
          >        
          <SearchClient onSelected={this.onSelected}/>    
          </OverlayTrigger>
          </Row>

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Job Title:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="jobtitle" id="jobtitle" onChange={this.onChangeJobTitle}></FormControl>
          </Col>

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Job Address:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="jobaddress" id="jobaddress" onChange={this.onChangeJobAddress}></FormControl>
          </Col>

          <Col  lg={8}>
            <FormLabel className='mb-2'>Job Description:</FormLabel>       
            <FormControl style={{maxWidth:"100%"}} type="text" name="jobdescription" id="jobdescription" onChange={this.onChangeJobDescription}></FormControl>
          </Col>   

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Start Date:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="date" name="jobstartdate" id="jobstartdate" onChange={this.onChangeJobStartDate}></FormControl>
          </Col>  

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>Due Date:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="date" name="jobendduedate" id="jobendduedate" onChange={this.onChangeJobDueDate}></FormControl>
          </Col>  

          {this.state.showerror && (
            <Alert variant="danger" onClose={() => this.setState({showerror:false})} dismissible>
              <Alert.Heading>Error</Alert.Heading>
              <p>{this.state.errmessage}</p>
            </Alert>      
          )}
          {this.state.showsuccess && (
            <Alert variant="success" onClose={() => this.setState({showsuccess:false})} dismissible>
              <Alert.Heading>Done</Alert.Heading>
              <p>{this.state.succmessage}</p>
            </Alert>      
          )}     
          { this.state.submitted ? (<Navigate push to="/jobs"/>) : null }     
          <hr/>
          <Row className='mb-2'>
            <Col className='col-md-3'>
              <Button id='savejob' onClick={this.handleValidations}>Save Job</Button>            
              <Button className='m-2' id='backToJobsList' onClick={this.goToJobsList}><IoIosArrowBack/></Button>            
            </Col>
          </Row>                                          
        </div>      
      </div>
      </>
    )      
  }
}

export default NewJob;